import styled from 'styled-components';

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 12px;
	gap: 0px;
	border-radius: 8px;
	position: relative;
`;

export const Attachments = styled.div`
	display: flex;
	flex-direction: row;
	gap: 12px;
	padding-top: 1px;
	margin-bottom: 4px;
	overflow-x: auto;
	&::-webkit-scrollbar {
		display: none;
	}
`;

export const DropZone = styled.div<{ backgroundImage?: string }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-family: 'Inter', sans-serif;

	gap: 16px;
	padding: 48px;
	border: 2px dashed ${({ theme }) => theme.gray[400]};
	border-radius: 8px;
	background-color: ${({ theme }) => theme.gray[100]};
	background-image: ${({ backgroundImage }) =>
		backgroundImage ? `url(${backgroundImage})` : 'none'};
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	min-height: 200px;

	// &:hover {
	// 	border-color: ${({ theme }) => theme.gray[600]};
	// 	background-color: ${({ theme }) => theme.gray[100]};
	// }
`;

export const DropZoneTitle = styled.div`
	font-size: 16px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const DropZoneSubtitle = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[600]};
	text-align: center;
	width: 300px;
	line-height: 1.3;
	margin-bottom: 8px;
`;

export const ChooseImageButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px 16px;
	background-color: ${({ theme }) => theme.gray[1000]};
	color: white;
	border: none;
	border-radius: 4px;
	font-size: 14px;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: ${({ theme }) => theme.gray[800]};
	}
`;

export const DragOverlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: ${({ theme }) => theme.gray[100]}DD;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	z-index: 1;
	border: 2px dashed ${({ theme }) => theme.gray[600]};
`;

export const DragOverlayContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
`;

export const DragOverlayText = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const DropZoneLoading = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
`;

export const DropZoneLoadingText = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const DropZoneSpacer = styled.div`
	position: absolute;
	bottom: 32px;
`;
